module.exports = __webpack_public_path__ + "img/-10_.ca3fed9e.svg";